const SelectEntity = ({currValue, choices, changeHandler}) => {

    return (
        <select value={currValue} onChange={changeHandler}>
            <option value=""></option>
            {choices.map(opt =>
                <option key={opt.id} value={opt.id}>{opt.label}</option>
            )}
        </select>
    )
}

export default SelectEntity